import { useQuery } from 'react-query';
import { CustomerCalendarApi } from '../../CustomerCalendarApi';
import { CancellationTiming, CustomerBooking } from '../../types';

export const CancellationTimingQueryKey = 'customer-booking-cancellation-timing';

export function useCancellationTimingQuery(booking: CustomerBooking | null) {
    const isPhoto = booking !== null && booking.kind === 'photo';

    return useQuery<CancellationTiming>(
        [CancellationTimingQueryKey, booking && booking.id],
        async () =>
            (await CustomerCalendarApi.precheckPhotoCancellation(booking!.calendarItemId))
                .bookingCancellationType,
        {
            enabled: isPhoto,
            staleTime: 0,
            cacheTime: 0,
            refetchOnWindowFocus: false
        }
    );
}
